import React from 'react';
import AutocompleteController, { AutocompleteControllerProps } from './AutocompleteController';

type ReferenceAutocompleteProps = Omit<AutocompleteControllerProps, 'returnObjectAsValue' | 'entityReferenceKey'>;

export default (props: ReferenceAutocompleteProps) => {
    return <AutocompleteController {...props} />;
};
